import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import SubHead from '../SubHead/SubHead';
import MiniHed from '../SubHead/MiniHed';
import BodyText from '../BodyText/BodyText';
import Button from '../../../common/Button';
import { decodeTags, sendLog } from '../../../../utils';
import './embed-module.scss';

class VideoEmbed extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    this.processEmbed = this.processEmbed.bind(this);
    this.processJWPlayer = this.processJWPlayer.bind(this);
    this.embed = null;
    this.isJW = false;
  }

  

  processEmbed(embed) {
    const encodedData = decodeTags(embed);
    return encodedData;
  }

  processJWPlayer(embed) {
    const dom = document.createElement('div');
    dom.innerHTML = embed;
    const src = dom.childNodes[0].getAttribute('src');
    const ids = src.replace('https://cdn.jwplayer.com/players/', '').replace('.js', '').replace('-', '_');
    const playerDivId = `botr_${ids}_div`;
    const playerDiv = document.createElement('div');
    playerDiv.id = playerDivId;
    document.getElementById('jwPlayer').appendChild(playerDiv);
    const script = document.createElement('script');
    script.src = src;
    document.getElementById('jwPlayer').appendChild(script);
  }

  componentDidMount() {
    if(this.isJW) {
      const embed = this.processEmbed(this.embed);
      try {    
        this.processJWPlayer(embed);
      } catch(e) {
        
      }
    }
  }

  componentDidUpdate() {
    if(this.isJW) {
      const embed = this.processEmbed(this.embed);
      try {    
        this.processJWPlayer(embed);
      } catch(e) {
        
      }
    }
  }

  render() {
    const { mounted } = this.state;
    const { data, className, onClick } = this.props;
    const { hed, hedBody, subhed, bodyText } = data;

    const isValid = (val) => {
      return (typeof(val) !== 'undefined' && val !== null && val !== "");
    };

    if (!isValid(data.jwplayer) && !isValid(data.embed)) {
      return null;
    }

    const jwplayer = isValid(data.jwplayer) ? data.jwplayer : null;
    const embed = isValid(data.embed) ? data.embed : jwplayer;
    const isJW = (embed === jwplayer);
    this.embed = embed;
    this.isJW = isJW;

    const encodedData = embed !== null ? this.processEmbed(embed) : '';
    const { buttonText, buttonUrl } = data;
    const button = (buttonText && buttonUrl) ? {text: buttonText, url: buttonUrl} : null;
    const renderedButton = button ? <Button button={button} /> : null;
    const renderedBodyText = bodyText ? <BodyText className="body-text" data={bodyText} /> : null;

    return (
        <Fragment>
          {hed && <SubHead className="sub-head" data={hed} />}
          {hedBody && <BodyText className="body-text" data={hedBody} />}
          {!isJW ?
          <div className={className} dangerouslySetInnerHTML={{ __html: encodedData }} />
          :
          <div className={className} id="jwPlayer"></div>
          }
          {subhed && <MiniHed className="sub-head" data={subhed} />}
          {renderedBodyText}
          {renderedButton}
        </Fragment>
    );
  }
}

VideoEmbed.propTypes = {
  className: PropTypes.string,
};

export default VideoEmbed;
